import api from '@pray/shared/utils/api/api';

import type { GetSegmentOptionsResponse } from './data/response';

/**
 * Get segment options for creating lead segments
 */
export async function getSegmentOptions() {
  const url = '/web/studio/lead-segments/options';
  const response = await api.executeGetRequest<GetSegmentOptionsResponse>(url);

  return response.data;
}
